import React from 'react';

import SectionModel from '../../models/sectionModel';

import {
    DEPOT_BUSINESS_PRICE, DEPOT_BUSINESS_PRICE_GET,
    DEPOT_BUSINESS_WOLT_EXPORT, RESTAURANT_RESET_PRICE,
} from '../../store/reducers/restaurant/restaurant-actions';

import {
    CONTROL_TYPE,
    MODEL_CONTROL_TYPE,
    ORDERING_MENU_TYPE_SECTION_MODEL,
    TYPE_SECTION_DEPOT_MODEL,
} from '../../utils/enums';
import { createBreadcrumbModel } from '../createBreadcrumbModel';
import {createControlModel, filtrateControlByDepotRole} from '../controlModelFactory';
import { getHistoryLocationParams } from '../../utils/routesHelper';
import { getDepotNameById } from '../restaurant';
import FilterOptionsModel from '../../models/filterOptionsModel.js';
import i18n from '../../i18n.js';
import {skuFilter} from "../filter.js";
import { Tooltip } from 'antd';

export function createDepotBusinessPriceSectionModel({ ...args }) {
    return new SectionModel({
        filterOptions: createDepotBusinessSKUSectionFilter(),
        columns: [
            {
                columns: [
                    {
                        title: 'settings.price_override.PROPERTY_NAME_LABEL',
                        accessor: 'name',
                        component: (item) => {
                            return <Tooltip className='itemWithTooltip' title={item.name}>
                                <span>{item.name}</span>
                            </Tooltip>
                        }
                    },
                  
                ],
                accessor: 'overrides',
                isEditable: true,
                type: CONTROL_TYPE.priceOverride,
            },
        ],
        initNewItemModel: item => {
            return item;
        },
        actionName: DEPOT_BUSINESS_PRICE,
        actionLoad: DEPOT_BUSINESS_PRICE_GET,
        actionOnUnmount: RESTAURANT_RESET_PRICE,
        typeAction: args.typeAction,
        typeModel: args.typeModel || ORDERING_MENU_TYPE_SECTION_MODEL.price,
        parentUrl: args.parentUrl || TYPE_SECTION_DEPOT_MODEL.depotsEdit,
        stayAfterSave: true,
        withSearch: true,
        breadcrumbs: [
            createBreadcrumbModel({
                label: 'settings.map.DEPOT_SETTINGS_LABEL',
            }),
            createBreadcrumbModel({
                getLabel: () => {
                    const { id } = getHistoryLocationParams(window.location.search);
                    return getDepotNameById(id);
                },
            }),
        ],
        label: 'settings.price_override.LABEL',
        controls: filtrateControlByDepotRole([
            createControlModel({
                type: MODEL_CONTROL_TYPE.back,
            }),
            createControlModel({
                type: MODEL_CONTROL_TYPE.iconControl,
                icon: 'export',
                hideTooltip: true,
                text: i18n.t('settings.price_override.EXPORT_WOLT'),
                action: DEPOT_BUSINESS_WOLT_EXPORT,
            }),
        ], [MODEL_CONTROL_TYPE.back, MODEL_CONTROL_TYPE.importFile]),
        mappingLambda: state => {
            return {
                values: state.restaurant.data?.priceOverrides,
                providers: state.restaurant.data?.priceOverridesSource,
            }
        },
    });
}

function createDepotBusinessSKUSectionFilter() {
    let filterOptionsModel = new FilterOptionsModel();

    filterOptionsModel.addOptions('search', CONTROL_TYPE.text, null, function(item) {
        return skuFilter(this.selected, item);
    });

    return filterOptionsModel;

}
